import ApiInterface from "../interface/ApiInterface";
import { InstitutionCertificateViewModel } from "../domain/models/InstitutionCertificateViewModel";


export default class InstitutionCertificateService {

}
